import NonAuthLayout from '../Layouts/NonAuthLayout' // IMPORTANT! : needs to be imported first

import MainLayout from '../Layouts/MainLayout' // IMPORTANT! : needs to be imported second

import AdminLayout from '../Layouts/AdminLayout/AdminLayout'

import { useSelector } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import auth from '../api/auth/hooks'
import Loader from '../Components/Common/Loader'
import { selectIsAuthenticated } from '../store/auth/selectors'
import { adminProtectedRoutes, authProtectedRoutes, publicRoutes } from './allRoutes'
import { AccessRoute, AuthProtected } from './AuthProtected'

const Index = () => {
    const isAuthenticated = useSelector(selectIsAuthenticated)
    
    const { data: agentHomepage, isPending } = auth.CurrentAgent.useQuery({ 
        enabled: isAuthenticated, 
        select: (data) => data.agentHomepage 
    })

    if (isAuthenticated && isPending) {
        return (
            <div className="full-page-loader">
                <Loader />
            </div>
        )
    }

    return (
        <>
            <Switch>
                {publicRoutes.map((route, idx) => (
                    <Route path={route.path} key={idx} exact={true}>
                        <NonAuthLayout>
                            <route.component />
                        </NonAuthLayout>
                    </Route>
                ))}

                {adminProtectedRoutes.map((route, idx) => (
                    <Route path={route.path} key={idx} exact={true}>
                        <AuthProtected>
                            <AdminLayout>
                                <AccessRoute path={route.path} component={route.component} />
                            </AdminLayout>
                        </AuthProtected>
                    </Route>
                ))}

                {authProtectedRoutes.map((route, idx) => (
                    <Route path={route.path} key={idx} exact={true}>
                        <AuthProtected>
                            <MainLayout>
                                <AccessRoute path={route.path} component={route.component} />
                            </MainLayout>
                        </AuthProtected>
                    </Route>
                ))}

                <Route path="*">
                    <AuthProtected>
                        <Redirect to={agentHomepage || '/properties'} />
                    </AuthProtected>
                </Route>
            </Switch>
        </>
    )
}

export default Index
